import * as types from '../actions/types';

const initialState = {
  list: [],
  list2: [],
  cathedra: {},
  loading: false,
  pageCount: 0
};

export default function cathedra(state = initialState, action) {
  switch (action.type) {
    case types.CATHEDRA_LIST_FETCH_COMPLETED:
      return {
        ...state,
        list: action.list,
        pageCount: action.pageCount
      };
    case types.CATHEDRA_LIST_FETCH_COMPLETED_2:
      return {
        ...state,
        list2: action.list
      };
    case types.CATHEDRA_FETCH_COMPLETED:
      return {
        ...state,
        cathedra: action.cathedra,
        loading: false
      };
    case types.CATHEDRA_FETCH_STARTED:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
